import CreateSurveyApi from "@/api/CreateSurveyApi";
import { Monitoring } from "@/utilities/monitoring";

export interface CreateSurveyDateInterface {
  type: String;
  property: String;
  date: String;
  name: String,
  userId: String;
}

export function useCreateSurvey() {
  async function fetchTemplates() {
    const templates = (await (CreateSurveyApi.getTemplates())).data.data
    return templates
  }

  async function sendDataToBackend(body: any) {
    try {
      const response = await CreateSurveyApi.postSurvey(body)
      return response
    } catch(err: any) {
      Monitoring.withScope((scope) => {
        scope.setContext("Create Survey Error", { body });
        Monitoring.error("Error while creating survey", err);
      });
    }
  }

  return {
    fetchTemplates,
    sendDataToBackend
  }
}
